import { TableWrapper } from "../utils/CallCenterTableWrapper";
import CallCenterTable from "./callCenterTable";
import helper from "../utils/helper";
import { message } from "antd";
import { errorMessage } from "../utils/commonStringsConsts";
import { useEffect, useState } from "react";
import tableHeaderConverter from "../utils/tableHeaderConverter";
import { useParams } from "react-router-dom";


interface TableState {
    tableTitle: string;
    data: any[];
    columns: { title: string; dataIndex: string; key: string }[];
    loading: boolean;
}

function CallCenterDashboardSharedTables() {
    const { userId }: { userId: string } = useParams<{ userId: string }>()
    const [tablesData, setTablesData] = useState<{ [key: string]: TableState }>({
        userInfo: { data: [], columns: [], loading: true, tableTitle: "Call Center: User Info" },
        userBalance: { data: [], columns: [], loading: true, tableTitle: "Call Center: User Balance by Phone" },
        companyInfo: { data: [], columns: [], loading: true, tableTitle: "Users - Company Profile - New" },
    });

    const fetchData = async (tableName: "userInfo" | "userBalance" | "companyInfo", fetchFunction: (userId: string) => Promise<any>) => {
        try {
            const response = await fetchFunction(userId);
            if (response?.status !== 200) {
                message.error(`${errorMessage} with ${tableName} data`);
                return;
            }
            const newData = response?.data?.data;
            const allCategoryNames = tableName === 'userInfo' ? (Array.from(new Set(
                newData?.flatMap((item: any) => item?.userTags?.map((tag: any) => tag?.categoryName) ?? []) ?? []
            )) as string[]).filter(Boolean) : [];
            const formattedData = newData?.map((item: any) => {
                const { userTags, ...rest } = item;
                const formattedUserTagsItem = tableName === 'userInfo' && userTags?.reduce((acc: Record<string, string | undefined>, tag: any) => {
                    return { ...acc, [tag.categoryName]: tag.tagName };
                }, {});
                const tagColumns = tableName === 'userInfo' ? allCategoryNames.reduce((acc: Record<string, string | undefined>, category) => {
                    acc[category] = formattedUserTagsItem?.[category];
                    return acc;
                }, {}) : {};
                return {
                    ...rest,
                    ...(tableName === 'userInfo' ? tagColumns : {}),
                    [tableName === 'userInfo' ? 'Hiring Date' : '']: item['Hiring Date'] ? helper.formatDate(item['Hiring Date'], 'MMMM D, YYYY') : '',
                    [tableName === 'companyInfo' ? 'feeslink' : '']: <a className='text-blue-400' href={item?.feeslink} download target="_blank" rel="noopener noreferrer">Click Here</a>,
                }
            });
            setTablesData((prev) => ({
                ...prev,
                [tableName]: {
                    data: formattedData,
                    columns: formattedData?.length > 0 ? tableHeaderConverter(formattedData) : [],
                    loading: false,
                    tableTitle: prev[tableName]?.tableTitle,
                },
            }));
        } catch (error) {
            setTablesData((prev) => ({ ...prev, [tableName]: { ...prev[tableName], loading: false, tableTitle: prev[tableName]?.tableTitle } }));
            setTablesData((prev) => ({ ...prev, [tableName]: { ...prev[tableName], loading: false } }));
        }
    };

    useEffect(() => {
        fetchData("userInfo", helper.getCallCenterUserInfo);
        fetchData("userBalance", helper.getCallCenterUserBalance);
        fetchData("companyInfo", helper.getCallCenterUserCompanyInfo);
        // eslint-disable-next-line
    }, []);

    return (
        <div className="unPaginatedTables">
            {Object.entries(tablesData)?.map(([key, table]) => (
                <TableWrapper key={key} title={key?.replace(/([A-Z])/g, " $1")?.replace(/^./, (str) => str?.toUpperCase()) + ":"}>
                    <CallCenterTable
                        title={table?.tableTitle}
                        rows={table?.data}
                        columns={table?.columns}
                        loading={table?.loading}
                        pagination={false}
                        scrolling={table?.loading ? {} : { x: "max-content" }}

                    />
                </TableWrapper>
            ))}
        </div>
    );
}

export default CallCenterDashboardSharedTables;
